// extracted by mini-css-extract-plugin
export default {"container":"fixedSideBar_container__8Wc2i","btn":"fixedSideBar_btn__HAXN6","btnClose":"fixedSideBar_btnClose__UoyJW"};